import Vue from "vue";

import BootstrapVue from "bootstrap-vue";
import "../style/bootstrap.scss";

Vue.use(BootstrapVue);
